import React, { useEffect } from 'react'
import Layout from '../../Components/Layout/Layout'
import wow from 'wowjs'
import 'animate.css';
import img2 from '../../Images/NewTemplate/bg_call_section.jpg'
import { NavLink } from 'react-router-dom'
import cimg from '../../Images/Pages/contact.png'

function About () {
  useEffect(() => {
    new wow.WOW().init()
  }, [])

  const sectionStyle = {
    background: `url(${cimg}) no-repeat`,
    backgroundSize: "cover",
    backgroundPosition: "center",
    height : "100%"

  }; 

  return (
    <>
      <Layout>
        <main>
        <section className="banner-blog overlay center" style={sectionStyle} >
    
    <div className="container my-2 ">
        <h1>About Us</h1>

        <p className='text-light'>Your Journey, Our Commitment – Experience Travel Like Never Before!</p>
        
       
        <nav aria-label="breadcrumb">
            <ol className="breadcrumb ">
                <li className="breadcrumb-item active "><NavLink to="/"><i className="fa fa-home"></i> Home</NavLink></li>
                <li className="breadcrumb-item">Contact Us</li>
            </ol>
        </nav>  
    </div>
</section>


             

          {/* ------ Why choose us----------- */}
     <section className="why-us">
        <div className="container">
            <div className="row justify-content-center wow animate__animated animate__zoomIn">
                <div className="col-10">
                    <h3>
                        See why people choose us
                    </h3>
                    <h6>
                        We help people find great products at a reasonable price
                    </h6>
                </div>
            </div>
            
            <div className="row">
                <div className="col-12 col-md-4 col-lg-4  wow animate__animated animate__bounceIn">
                    <div className="why-item">
                    <i class='icofont-medal'></i>
                        <h2>
                        + 1000 Customers
                        </h2>
                        <p>
                        Join over 1,000 satisfied customers who trust us to turn their travel dreams into reality. Discover why we're the go-to choice for unforgettable journeys!
                        </p>
                    </div>
                </div>
                <div className="col-sm-12 col-md-4 col-lg-4 wow animate__animated animate__bounceIn">
                    <div className="why-item">
                    <i class='icofont-support'></i>
                        <h2>
                        24/7 Support
                        </h2>
                        <p>  With 24/7 support, we're always here to assist you, ensuring a smooth and worry-free travel experience anytime, anywhere!
                        </p>
                    </div>
                </div>
                <div className="col-sm-12 col-md-4 col-lg-4 wow animate__animated animate__bounceIn">
                    <div className="why-item">
                    <i class='icofont-bank-alt'></i>
                        <h2>
                        WorldWide Locations
                        </h2>
                        <p>
                        Explore the world with ease through worldwide locations, offering you access to incredible destinations across the globe!
                        </p>
                    </div>
                </div>
                <div className="col-sm-12 col-md-4 col-lg-4 wow animate__animated animate__bounceIn">
                    <div className="why-item">
                    <i class='icofont-ui-head-phone'></i>
                        <h2>
                        Help Direct Line
                        </h2>
                        <p>
                        Get immediate assistance with our Help Direct Line, connecting you to expert support for all your travel needs, anytime you require it!
                        </p>
                    </div>
                </div>
                <div className="col-sm-12 col-md-4 col-lg-4 wow animate__animated animate__bounceIn">
                    <div className="why-item">
                    <i class='icofont-credit-card'></i>
                        <h2>
                        Secure Payments
                        </h2>
                        <p>
                        Enjoy peace of mind with our secure payment options, ensuring your transactions are safe and protected every step of the way!
                        </p>
                    </div>
                </div>
                <div className="col-sm-12 col-md-4 col-lg-4 wow animate__animated animate__bounceIn">
                    <div className="why-item">
                    <i class='icofont-chat'></i>
                        <h2>
                        Support via Chat
                        </h2>
                        <p>
                        Experience instant assistance through our chat support, where our friendly team is ready to help you with any queries!
                        </p>
                    </div>
                </div>
            </div>
        </div>
    </section>

      {/* -------------tag-line---------------- */}
      <section className="about-tag">
        <div className="container">
            <div className="row justify-content-center wow animate__animated animate__zoomIn">
                <div className="col-10">
                    <h3>
                        Our passion for customer excellence is just one reason why we are the market leader. We've always worked very hard to give our customers the best experience in dealing with our company.
                    </h3>
                </div>
            </div>
        </div>
    </section> 

    
        {/* ---------------clints------------- */}
    <section className="client-bg">
        <div className="container">
            <div className="row justify-content-center wow animate__animated animate__fadeIn">
                <div className="col-10 ">
                    <h3>
                    Our Origins and Story
                    </h3>
                    <h6>
                    Where Passion for Travel Meets Unforgettable Adventures!
                    </h6>
                </div>
            </div>
            
            <div className="row">
                
               <div className="col-md-6 wow wow animate__animated animate__slideInLeft">
               <img src={img2} class='img-fluid' alt='' />
               </div>
               <div className="col-md-6 mt-4 wow animate__animated animate__slideInRight">
                <p>
                At Shayaan Travel & Tour, our journey began with a simple yet powerful vision: to connect people with the wonders of travel. Founded in the heart of the UK, we have grown from a small local agency into a trusted partner for travelers seeking unique and unforgettable experiences. Our founders, driven by their passion for exploration, realized the need for personalized travel solutions that cater to every type of adventurer.
                </p>
                <p className='mt-4'>
                Over the years, Shayaan Travel & Tour has established a reputation for reliability and excellence in the travel industry. Our commitment to quality service and customer satisfaction has attracted a loyal clientele, and we take pride in being a part of countless memorable journeys. With a team of experienced travel experts, we are here to guide you through every step of your travel planning process, ensuring that your trips are not just vacations but lifelong memories.
                </p>
               </div>

            </div>
        </div>
    </section>
  
        </main>
      </Layout>
    </>
  )
}

export default About
